import { api } from '@/lib/api';
import { createFileRoute } from '@tanstack/react-router';
import EmpresasBanco from './-component';

export const Route = createFileRoute(
  '/__authenticated/comercial/produto/clientes/web/$codigo/empresas-banco/',
)({
  context: ctx => ({
    empresasBancoQueryOptions: api.queryOptions(
      'get',
      '/clientes/servicos-web/{codigo}/empresas',
      {
        params: { path: { codigo: ctx.params.codigo } },
      },
      // A API já faz retries.
      { staleTime: 1000 * 60, retry: false },
    ),
  }),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(context.empresasBancoQueryOptions);
  },
  component: EmpresasBanco,
});
